export const BEFORE_FETCH_DASHBOARD_TRANSACTIONS = 'BEFORE_FETCH_DASHBOARD_TRANSACTIONS';
export const FETCH_DASHBOARD_TRANSACTIONS = 'FETCH_DASHBOARD_TRANSACTIONS';
export const NETWORK_ERROR_FETCHING_DASHBOARD_TRANSACTIONS = 'NETWORK_ERROR_FETCHING_DASHBOARD_TRANSACTIONS';